var map = {
	"./AA-Stetica-Bold.woff": 6187,
	"./AA-Stetica-Light.woff": 2495,
	"./AA-Stetica-Medium-Italic_1.woff": 3402,
	"./AA-Stetica-Medium.woff": 3432,
	"./AA-Stetica-Regular.woff": 9218,
	"./FoglihtenNo06.woff": 2980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2221;